// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReportStatusesWidget__Component .ReportStatusesWidget__Component__Status[data-v-a0eb1ef0] {\n  display: flex;\n  background-color: #b6dcf5;\n  border-radius: 3px;\n  padding: 2px 10px;\n  margin: 7px 0;\n  flex-direction: column;\n}\n.ReportStatusesWidget__Component .ReportStatusesWidget__Component__Status span[data-v-a0eb1ef0] {\n    margin: 0 2px;\n    display: block;\n}\n", ""]);
// Exports
module.exports = exports;
